<template>
  <div
    v-if="newNoticeInfo.title"
    v-show="show"
    class="full-tips"
  >
    <i class="iconfont iconNotice" />
    <div
      ref="wrap"
      class="wrap"
    >
      <div
        ref="marquee"
        :style="pos"
        class="marquee clearfix"
      >
        <div
          ref="text"
          class="text"
        >
          <a
            v-if="newNoticeInfo.link"
            :href="newNoticeInfo.link"
            target="_blank"
            :style="{color: newNoticeInfo.style || '#666'}"
          >{{ newNoticeInfo.title }}</a>
          <span
            v-else
            :style="{color: newNoticeInfo.style || '#666'}"
          >{{ newNoticeInfo.title }}</span>
        </div>
      </div>
    </div>
    <i
      class="close-btn iconfont iconicon-test28"
      @click="handleClose"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      show: true,
      textsWidth: 0,
      distance: 0,
      timer: null
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('newFeature', ['newNoticeInfo']),
    annoce () {
      const { announce2 } = this.baseinfo || {}
      return announce2
    },
    pos () {
      return {
        width: this.textsWidth * 2 + 'px',
        transform: `translate3d(${-this.distance}px, 0, 0)`,
        // transform: `translate(${-this.distance}px, 0px) translateZ(0)`,
        transition: `all 0s`
      }
    }
  },
  async mounted () {
    if (this.annoce) {
      let chain = await this.getNewNoticeInfo({ type: 2 })
      chain.onSuccess(res => {
        // this.newNoticeInfo.title = ''
        this.zMarquee(30)
      })
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    ...mapActions('newFeature', ['getNewNoticeInfo', 'closeNewAnnounce']),
    zMarquee (speedParam) {
      let self = this
      let parent = this.$refs.wrap
      let child = this.$refs.marquee
      let speed = speedParam || 40 // 跑马灯速度
      this.timer = null
      this.distance = 1

      if (parent.offsetWidth >= child.scrollWidth) {
        parent.style.width = child.scrollWidth - this.$scalePx(30) + 'px'
        this.textsWidth = child.scrollWidth
        return
      }

      this.textsWidth = child.scrollWidth + this.$scalePx(2) // 跑马灯内容
      child.innerHTML += child.innerHTML
      self.timer = setInterval(() => {
        if (self.distance >= self.textsWidth) {
          self.distance = 0
        }
        self.distance++
      }, speed)
    },
    async handleClose () {
      this.show = false
      const { annid } = this.newNoticeInfo || {}
      await this.closeNewAnnounce({
        annid
      })
    }
  }
}
</script>

<style scoped lang="scss">
.full-tips {
  display: flex;
  justify-content: center;
  margin-top: -11px;
  padding: 10px 36px 10px 16px;
  color: #5077AA;
  background: #E8F4FF;
  border-bottom: solid 1px #d8d8d8;
  .iconNotice {
    margin-left: -4px;
    margin-right: 4px;
    color: #51a2ef;
    font-size: 16px;
  }
  .wrap {
    width: 343px;
    height: 16px;
    padding: 0 1px;
    line-height: 16px;
    overflow: hidden;
    .marquee {
      width: 999999px;
      height: 100%;
    }
    .text {
      float: left;
      padding-right: 30px;
      white-space: nowrap;
      font-size: 12px;
      transform: translate3d(0,0,0);
      backface-visibility:hidden;
      perspective:1000;
    }
  }
  .close-btn {
    position: absolute;
    right: 10px;
    top: 8px;
    margin-left: 20px;
    color: #5077AA;
    font-size: 20px;
  }
}
</style>
